var _defs, _circle, _path, _circle2, _path2, _circle3, _path3, _path4, _circle4, _path5, _path6, _circle5, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpatterSafe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    "data-name": "Lager 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29 23.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: 0px;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 4.4,
    cy: 1,
    r: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m25.75,4.5c0-.11.01-.22.04-.32-1.61.46-5.78,2.83-7.79,5.57-2.19,2.99-3.08,6.53-3.41,8.25-.06.31-.09.49-.09.49,0,.14.11.26.25.26s.25-.12.25-.26c0,0,.03-.16.09-.43.35-1.61.91-4.31,3.91-8.06,2.16-2.71,5.83-4.08,7.24-4.4-.3-.27-.48-.66-.48-1.1Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 27.25,
    cy: 4.5,
    r: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m14.75,2.75c-.3,0-.55-.13-.74-.34l.49,16.09c0,.14.11.25.25.25s.25-.11.25-.25l.49-16.09c-.18.2-.44.34-.74.34Z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 14.75,
    cy: 1.25,
    r: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m21.37,22.03c-1.9.27-4.07.43-6.37.43-7.59,0-13.75-1.68-13.75-3.75,0-1.46,3.05-2.72,7.5-3.34v-1.2c-5.16.79-8.75,2.52-8.75,4.54,0,2.76,6.72,5,15,5,2.67,0,5.18-.24,7.35-.64-.34-.3-.68-.65-.98-1.03Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m25.56,12.88c-.37-.11-.75-.11-1.11,0-1.1.32-3.44,1.08-3.44,1.85,0,1,.34,3.86.8,5,.71,1.77,2.66,2.75,3.11,2.96.06.03.12.03.18,0,.44-.21,2.4-1.19,3.11-2.96.46-1.14.8-4,.8-5,0-.77-2.34-1.53-3.44-1.85Zm2.05,3.45l-2.95,2.95c-.16.16-.43.16-.59,0l-.29-.29-.88-.88c-.16-.16-.16-.43,0-.59.16-.16.43-.16.59,0l.74.74c.08.08.22.08.3,0l2.5-2.5c.16-.16.43-.16.59,0,.16.16.16.43,0,.59Z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 22.15,
    cy: 1.4,
    r: 1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m20.79,1.92c-.66.69-1.78,1.67-2.79,3.48-.75,1.35-1,1.35-2.36,5.72-.04.13,0,.27.13.33s.28,0,.33-.13c.9-2.58,2.17-4.72,2.9-5.78,1.25-1.8,2.1-2.37,2.55-2.84-.36-.13-.64-.42-.76-.79Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m14.91,18c-.33-1.71-2.66-7.63-4.66-10.75-1.49-2.32-3.13-4.54-4.36-5.87-.13.4-.55.74-.89.98,1.23,1.17,3.14,3.46,4.5,5.63,2.5,4,4.55,8.46,4.91,10.06.06.27.09.43.09.43,0,.14.11.26.25.26s.25-.12.25-.26c0,0-.03-.18-.09-.49Z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 11.25,
    cy: 4.25,
    r: 1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m12.53,6.25c-.13-.32-.25-.6-.37-.87-.18.13-.39.22-.61.29.12.26.24.53.38.84,1.29,2.88,1.4,4.75,1.4,4.75,0,.14.11.25.25.25s.25-.11.25-.25c0,0-.48-3.03-1.3-5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpatterSafe);
export default __webpack_public_path__ + "static/media/spatter_safe.ab663ea93ddc8bbc69387b8122a5dbc8.svg";
export { ForwardRef as ReactComponent };